// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__28xOF","elForm":"Section_elForm__1Ow52","securityField1":"Section_securityField1__gePUJ","otherField":"Section_otherField__shYHM"};